export const heroSlides = [
  {
    id: "h1",
    title: "《长夜将尽》正式杀青",
    subtitle: "筱田优挑战全新冷峻角色，长夜之下，真相从不明亮",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20rainy%20city%20street%20at%20night%20with%20glowing%20neon%20signs%20and%20wet%20reflective%20asphalt%2C%20deep%20indigo%20and%20violet%20shadows%20with%20warm%20amber%20highlights%2C%20moody%20film%20noir%20atmosphere%2C%20no%20text%2C%20high%20detail%2C%20cinematic%20composition&width=1600&height=900&seq=hero-c01&orientation=landscape",
    newsId: "n1",
  },
  {
    id: "h2",
    title: "科幻新作《光年之外》首曝预告",
    subtitle: "在光年之外的旅途中，孤独是最长的一段距离",
    image:
      "https://readdy.ai/api/search-image?query=Epic%20abstract%20space%20scene%20with%20a%20vast%20colorful%20nebula%20and%20distant%20stars%20over%20a%20dark%20indigo%20cosmos%2C%20soft%20amber%20and%20teal%20glow%2C%20dreamlike%20and%20minimal%2C%20no%20text%2C%20cinematic%20wide%20composition%2C%20high%20detail&width=1600&height=900&seq=hero-c02&orientation=landscape",
    newsId: "n2",
  },
  {
    id: "h3",
    title: "专访筱田优：表演是一场旅程",
    subtitle: "每一次出现，都希望让观众看到一个不一样的自己",
    image:
      "https://readdy.ai/api/search-image?query=Intimate%20cinematic%20studio%20scene%20with%20a%20simple%20chair%20under%20soft%20warm%20backlight%2C%20muted%20indigo%20background%20with%20gentle%20amber%20glow%2C%20calm%20and%20reflective%20mood%2C%20no%20text%2C%20editorial%20photography%2C%20high%20detail&width=1600&height=900&seq=hero-c03&orientation=landscape",
    newsId: "n7",
  },
];